// COMMON
export const SITE_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN || "";
export const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME || process.env.NEXT_PUBLIC_DOMAIN || "";

export const LOCAL_DOMAIN = process.env.NEXT_PUBLIC_LOCAL_DOMAIN;

// STRAPI
export const API_TOKEN = process.env.NEXT_PUBLIC_STRAPI_API_TOKEN;

export const API_URL = process.env.NEXT_PUBLIC_STRAPI_API_URL || `https://cms.${SITE_DOMAIN}`;

export const isStage = !!SITE_DOMAIN?.match(/(devstage.cloud|vercel.app)/);

// CORE API
export const CORE_API_URL =
  process.env.NEXT_PUBLIC_CORE_API_URL || "https://api.customer-core.devstage.cloud"; // same for all sites

// OTHER
export const __ARTICLES_PAGE_SIZE = 6;

export const ARTICLES_PER_PAGE = 12;

export const ORDER_LINK = `https://app.${SITE_DOMAIN}/order`;

export const HAS_SAMPLES_PAGES = false;

export const TOTAL_PREVIEW_ARTICLES_IN_CATEGORY = 20;
